import { Typography } from '@mui/material';
import { Box, Stack, useTheme } from '@mui/system';

import VectorImage from '~components/media/vectorImage';
import { Dimens } from '~themes';

interface Props {
	showIcon?: boolean;
	showLabel?: boolean;
	size?: number;
}

const SkopeiConnectLogo = ({ showIcon = true, showLabel = true, size = undefined }: Props) => {
	const theme = useTheme();
	const { palette } = theme;
	return (
		<Stack direction='row' gap={Dimens.spacingMd} sx={{ display: 'inline-flex', width: '100%' }}>
			{showIcon && (
				<Box sx={{ lineHeight: 0 }}>
					<VectorImage name='icon/skopei' size={size ?? (showLabel ? 32 : 40)} />
				</Box>
			)}
			{showLabel && (
				<Stack direction='row' alignItems='center' gap={Dimens.spacingXs}>
					<Typography variant='labelLg' color={palette.textPrimary.main} component='span'>
						Skopei
					</Typography>
					<Typography variant='paragraphLg' color={palette.textPrimary.main} component='span'>
						Connect
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};

export default SkopeiConnectLogo;
